import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import api from '../../services/api'

/**
 * El badge de la campana. Cuenta solo las NUEVAS.
 *
 * Antes estaba cableado a `0` en el layout: un badge que siempre decia cero, o sea una
 * señal configurada para no disparar nunca. Ahora pregunta al backend.
 *
 * "Nueva" deja de serlo cuando el contador ABRE el aviso, no cuando ve la lista. Si bastara
 * con abrir la campana, el contador habria "leido" veinte avisos sin leer ninguno y `read_at`
 * dejaria de medir si el canal sirve.
 */
const NotificationBell = () => {
  const { data } = useQuery(
    'notificaciones-nuevas',
    async () => {
      const { data } = await api.get('/notifications/notifications/unread_count/')
      return data?.unread_count ?? 0
    },
    { refetchInterval: 60000, refetchOnWindowFocus: true, staleTime: 30000 }
  )

  const nuevas = data ?? 0

  return (
    <Nav.Link as={Link} to="/notifications" aria-label={`Notificaciones: ${nuevas} sin leer`}>
      Notificaciones
      {nuevas > 0 && (
        <span className="badge bg-danger ms-1" data-testid="badge-notificaciones">
          {nuevas > 99 ? '99+' : nuevas}
        </span>
      )}
    </Nav.Link>
  )
}

export default NotificationBell
